import axios from "axios";
import { generateUrl } from "./generateUrl";

export const hubIdStorage = "2SSDGHJIolmVCx_HUBID";

export const verifyUser = async () => {
    const currentHubId = localStorage.getItem(hubIdStorage);

    if (!currentHubId) return false;

    return await axios
        .get(generateUrl(`customer/get/by_hub_id/${currentHubId}`))
        .then((res: any) => res.data)
        .catch(() => false);
};

export const createHubId = async (invitation_code: string) => {
    return await axios
        .post(generateUrl("customer/create/"), { invitation_code })
        .then((res: any) => {
            localStorage.setItem(hubIdStorage, res.data?.hub_id);

            return res.data;
        })
        .catch((err) => ({
            isError: true,
            data: err.response.data,
        }));
};
